import { Box, Button, FormControlLabel, Grid, Icon, IconButton, Switch, TextField, Typography } from "@mui/material";
import InputMascarado from "../../../../shared/components/formulario/input-mascarado/InputMascarado";
import { mascaraMoedaReal } from "../../../../shared/utils/mascaras/mascaraMoedaReal";
import { SelectUnitOfMeasure, UnitOfMeasureEnum } from "../../../../shared/components/formulario/select/SelectUnitOfMeasure";
import { Controller } from "react-hook-form";

export function TabOrcamentoEmpresa({ empresaRaw, control, errors, methods, setTab, mdDown }: any) {
    return (
        <Box>
            <Typography variant="h6" gutterBottom paddingBottom={3}>
                Configuração Mão de Obra
            </Typography>
            <Controller
                name="laborBudget"
                control={control}
                render={({ field }) => (
                    <>
                        {(field.value || []).map((item: any, idx: number) => (
                            <Grid container spacing={2} key={item.id || idx} alignItems="center" mb={4}>
                                <Grid item xs={12} md={2}>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={!!item.isClt}
                                                onChange={e => {
                                                    const newArr = [...field.value];
                                                    newArr[idx].isClt = e.target.checked;
                                                    field.onChange(newArr);
                                                }}
                                            />
                                        }
                                        label="CLT"
                                    />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <TextField
                                        label="Descrição do Cargo"
                                        value={item.description}
                                        onChange={e => {
                                            const newArr = [...field.value];
                                            newArr[idx].description = e.target.value;
                                            field.onChange(newArr);
                                        }}
                                        fullWidth
                                        size="small"
                                    />
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <SelectUnitOfMeasure
                                        name={`laborBudget.${idx}.unitOfMeasure`}
                                        control={control}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    {item.isClt ? (
                                        <Grid container spacing={1}>
                                            <Grid item xs={12} md={6}>
                                                <InputMascarado
                                                    name={`laborBudget.${idx}.baseWage`}
                                                    methods={methods}
                                                    value={item.baseWage}
                                                    label="Salário Base"
                                                    mask={mascaraMoedaReal}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <InputMascarado
                                                    name={`laborBudget.${idx}.wage`}
                                                    methods={methods}
                                                    value={(() => {
                                                        const chargesCltStr = localStorage.getItem("chargesClt");
                                                        let chargesClt = 0;
                                                        if (chargesCltStr) {
                                                            chargesClt = parseFloat(chargesCltStr.replace(/\./g, '').replace(',', '.'));
                                                        }
                                                        let baseWage = item.baseWage;
                                                        if (typeof baseWage === 'string') {
                                                            baseWage = parseFloat(baseWage.replace(/\./g, '').replace(',', '.'));
                                                        } else {
                                                            baseWage = Number(baseWage) || 0;
                                                        }
                                                        if (!baseWage) return '';
                                                        const total = baseWage + (baseWage * (chargesClt / 100));
                                                        return total;
                                                    })()}
                                                    label="Salário Total CLT"
                                                    mask={mascaraMoedaReal}
                                                    disabled
                                                />
                                            </Grid>
                                        </Grid>
                                    ) : (
                                        <InputMascarado
                                            name={`laborBudget.${idx}.wage`}
                                            methods={methods}
                                            value={item.wage}
                                            label="Salário"
                                            mask={mascaraMoedaReal}
                                        />
                                    )}
                                </Grid>
                                <Grid item xs={12} md={1}>
                                    <IconButton
                                        size="medium"
                                        color="error"
                                        onClick={() => {
                                            const newArr = [...field.value];
                                            newArr.splice(idx, 1);
                                            field.onChange(newArr);
                                        }}
                                    >
                                        <Icon>delete</Icon>
                                    </IconButton>
                                </Grid>
                            </Grid>
                        ))}
                        <Button
                            variant="outlined"
                            onClick={() => {
                                const newArr = field.value ? [...field.value] : [];
                                newArr.push({ id: undefined, isClt: false, description: '', unitOfMeasure: UnitOfMeasureEnum.UNIT, wage: 0 });
                                field.onChange(newArr);
                            }}
                        >
                            Adicionar Orçamento de Mão de Obra
                        </Button>
                    </>
                )}
            />

            {/* profitMarginBudget - lista dinâmica */}
            <Box mt={4} borderTop="1px solid #ccc" pt={2}>
                <Typography variant="subtitle1" gutterBottom paddingBottom={2}>
                    Margens de Lucro por Orçamento
                </Typography>
                <Controller
                    name="profitMarginBudget"
                    control={control}
                    render={({ field }) => (
                        <>
                            {(field.value || []).map((item: any, idx: number) => (
                                <Grid container spacing={2} key={item.id || idx} alignItems="center" mb={4}>
                                    <Grid item xs={12} md={4}>
                                        <TextField
                                            label="Nome do Orçamento"
                                            value={item.name}
                                            onChange={e => {
                                                const newArr = [...field.value];
                                                newArr[idx].name = e.target.value;
                                                field.onChange(newArr);
                                            }}
                                            fullWidth
                                            size="small"
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextField
                                            label="Valor (%)"
                                            type="number"
                                            value={item.value}
                                            onChange={e => {
                                                const newArr = [...field.value];
                                                newArr[idx].value = Number(e.target.value);
                                                field.onChange(newArr);
                                            }}
                                            fullWidth
                                            size="small"
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={1}>
                                        <IconButton
                                            size="medium"
                                            color="error"
                                            onClick={() => {
                                                const newArr = [...field.value];
                                                newArr.splice(idx, 1);
                                                field.onChange(newArr);
                                            }}

                                        >
                                            <Icon>delete</Icon>
                                        </IconButton>

                                    </Grid>
                                </Grid>
                            ))}
                            <Button
                                variant="outlined"
                                onClick={() => {
                                    const newArr = field.value ? [...field.value] : [];
                                    newArr.push({ id: '', name: '', value: 0 });
                                    field.onChange(newArr);
                                }}
                            >
                                Adicionar Margem de Lucro
                            </Button>
                        </>
                    )}
                />
            </Box>
            <Box mt={2} display="flex" justifyContent="space-between">
                <Button variant="outlined" onClick={() => setTab(2)}>
                    Voltar
                </Button>
            </Box>
        </Box>
    )
}